import React from "react";

/*
 * Icons traced from OS-design-system `packages/web/src/icons/source`
 * (Plus.svg, Minus.svg, External Link.svg), inlined for the same reason design-tokens.css inlines
 * the tokens: matrix does not depend on @exp-is/design-system, which publishes
 * to npm.pkg.github.com and would need an authenticated .npmrc in CI.
 *
 * The source files hardcode `stroke="#212121"` (Neutral 900). These use
 * `currentColor` instead so the icon follows the button's own text colour and
 * therefore works in both themes — the one deliberate deviation from source.
 */

const iconProps = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
};

const PlusIcon = () => (
  <svg {...iconProps}>
    <path d="M6 12H12M18 12H12M12 12V6M12 12V18" stroke="currentColor" />
  </svg>
);

const MinusIcon = () => (
  <svg {...iconProps}>
    <path d="M6 12H18" stroke="currentColor" />
  </svg>
);

// External Link.svg: a booking that belongs to another node (shared resource).
const ExternalLinkIcon = () => (
  <svg {...iconProps}>
    <path d="M21 9V3L15 3M21 3L12 12" stroke="currentColor" />
    <path d="M21 13V21H3V3H11" stroke="currentColor" />
  </svg>
);

export { PlusIcon, MinusIcon, ExternalLinkIcon };
